const QBANK_FLOW_STORAGE_KEY = "vidya-kasam:qbank-flow";
const QUESTION_BANK_CATEGORY_ID = 2;

function cloneIfObject(value) {
  return value && typeof value === "object" ? { ...value } : null;
}

function toPositiveNumber(value, fallback = 0) {
  const nextValue = Number(value);
  return Number.isFinite(nextValue) && nextValue > 0 ? nextValue : fallback;
}

export function getStoredQuestionBankFlowState() {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const rawValue = window.sessionStorage.getItem(QBANK_FLOW_STORAGE_KEY);
    return rawValue ? JSON.parse(rawValue) : {};
  } catch (_error) {
    return {};
  }
}

export function buildQuestionBankFlowState(routeState = {}, fallbackState = {}) {
  const mergedState = {
    ...fallbackState,
    ...routeState,
  };

  const stateId = toPositiveNumber(
    routeState?.state_id || routeState?.states_id || routeState?.stateId || routeState?.selectedState?.state_id ||
      mergedState?.selectedState?.state_id ||
      mergedState?.state_id ||
      mergedState?.topicRequestParams?.state_id ||
      mergedState?.subTopicRequestParams?.state_id ||
      mergedState?.listQueryState?.state_id ||
      fallbackState?.state_id,
    0
  );
  const categoryId = toPositiveNumber(
    routeState?.category_id || routeState?.categoryId || routeState?.selectedCategory?.category_id ||
      mergedState?.selectedCategory?.category_id ||
      mergedState?.category_id ||
      mergedState?.topicRequestParams?.category_id ||
      mergedState?.subTopicRequestParams?.category_id ||
      fallbackState?.category_id,
    QUESTION_BANK_CATEGORY_ID
  );

  const selectedState = cloneIfObject(mergedState?.selectedState) || {
    state_id: stateId,
    state_name: mergedState?.state_name || mergedState?.stateName || fallbackState?.state_name || "",
  };
  const selectedCategory = cloneIfObject(mergedState?.selectedCategory) || {
    category_id: categoryId,
    id: categoryId,
    title: mergedState?.category_name || mergedState?.categoryName || "Question Bank",
    category_name: mergedState?.category_name || mergedState?.categoryName || "Question Bank",
  };
  selectedState.state_id = stateId;
  selectedCategory.category_id = categoryId;
  selectedCategory.id = categoryId;
  const selectedSubject = cloneIfObject(mergedState?.selectedSubject);
  const selectedBattle = cloneIfObject(mergedState?.selectedBattle);
  const selectedTopic = cloneIfObject(mergedState?.selectedTopic);
  const selectedSubtopic = cloneIfObject(mergedState?.selectedSubtopic);
  const listQueryState = cloneIfObject(mergedState?.listQueryState) || {};

  const topicRequestParams = cloneIfObject(mergedState?.topicRequestParams) ||
    (selectedSubject
      ? {
          state_id: stateId,
          subject_id: toPositiveNumber(selectedSubject?.id || mergedState?.subject_id, 0),
          category_id: categoryId,
        }
      : null);

  const subTopicRequestParams = cloneIfObject(mergedState?.subTopicRequestParams) ||
    (selectedTopic
      ? {
          state_id: stateId,
          subject_id: toPositiveNumber(mergedState?.subject_id || topicRequestParams?.subject_id, 0),
          topic_id: toPositiveNumber(selectedTopic?.id || mergedState?.topic_id, 0),
          category_id: categoryId,
        }
      : null);

  const qbankBackTarget = mergedState?.qbankBackTarget
    ? {
        pathname: mergedState.qbankBackTarget.pathname,
        state: cloneIfObject(mergedState.qbankBackTarget.state) || {},
      }
    : null;

  return {
    ...fallbackState,
    ...routeState,
    selectedState,
    selectedCategory,
    selectedSubject,
    selectedBattle,
    selectedTopic,
    selectedSubtopic,
    topicRequestParams,
    subTopicRequestParams,
    listQueryState,
    state_id: stateId,
    state_name: selectedState?.state_name || mergedState?.state_name || "",
    category_id: categoryId,
    subject_id: toPositiveNumber(
      mergedState?.subject_id || selectedSubject?.id || topicRequestParams?.subject_id || subTopicRequestParams?.subject_id,
      0
    ),
    topic_id: Math.max(0, Number(mergedState?.topic_id ?? mergedState?.topicId ?? selectedSubtopic?.id ?? selectedTopic?.id ?? subTopicRequestParams?.topic_id ?? 0) || 0),
    is_topic_specific: Number(mergedState?.is_topic_specific ?? fallbackState?.is_topic_specific ?? 0),
    is_parent_topic: Number(mergedState?.is_parent_topic ?? fallbackState?.is_parent_topic ?? 0),
    qbankBackTarget,
  };
}

export function persistQuestionBankFlowState(flowState) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.setItem(
      QBANK_FLOW_STORAGE_KEY,
      JSON.stringify(flowState || {})
    );
  } catch (_error) {
    // Ignore storage failures and fall back to route state.
  }
}

export function buildQuestionBankBackTarget(pathname, state = {}) {
  return {
    pathname,
    state: buildQuestionBankFlowState({ ...state, qbankBackTarget: null }),
  };
}

export function buildQuestionBankSubjectsState(flowState = {}) {
  const resolvedFlowState = buildQuestionBankFlowState(flowState);

  return buildQuestionBankFlowState({
    selectedState: resolvedFlowState.selectedState,
    selectedCategory: resolvedFlowState.selectedCategory,
    selectedBattle: resolvedFlowState.selectedBattle,
    state_id: resolvedFlowState.state_id,
    state_name: resolvedFlowState.state_name,
    category_id: resolvedFlowState.category_id,
  });
}

